import { render, staticRenderFns } from "./SellOutTip.vue?vue&type=template&id=71f60c82&scoped=true"
import script from "./SellOutTip.vue?vue&type=script&lang=js"
export * from "./SellOutTip.vue?vue&type=script&lang=js"
import style0 from "./SellOutTip.vue?vue&type=style&index=0&id=71f60c82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f60c82",
  null
  
)

export default component.exports